import type { TourFrame } from '@carboncopyco/types';
import { AnalyticsTrackEventName, useAnalytics } from '@carboncopyco/utils';

interface Props {
  tourId: string;
  selectedFrameIndex: number;
  frames: TourFrame[];
}

const useTitleBarActions = ({ tourId, selectedFrameIndex, frames }: Props) => {
  const { trackEvent } = useAnalytics();

  const handleAddNewFrames = () => {
    trackEvent(AnalyticsTrackEventName.TOUR_CLICK_OPEN_ADD_FRAME_MODAL, {
      tourId,
      location: 'tour_editor',
      insertIndex: selectedFrameIndex + 1,
    });
    const stepConfig = setStepConfigToInheritFrom();
    if (stepConfig) {
      localStorage.setItem(
        `stepConfigToInheritFrom-${tourId}`,
        JSON.stringify(stepConfig)
      );
    }
  };

  const setStepConfigToInheritFrom = () => {
    for (let i = selectedFrameIndex; i >= 0; i--) {
      if (frames[i].isActive && frames[i].steps.length > 0) {
        return frames[i].steps[frames[i].steps.length - 1].config;
      }
    }
  };

  return {
    handleAddNewFrames,
  };
};

export default useTitleBarActions;
